import React from "react";

import { useMutation } from "@apollo/react-hooks";
import { Form, Input } from "antd";
import { FormComponentProps } from "antd/lib/form";
import gql from "graphql-tag";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";

import { Routes } from "../../../constants";
import { colorTokens } from "../../../cssConstants";
import { publicClient } from "../../../graphql";
import { AuthCTAButton } from "../../auth/styledComponents";
import { B3, FormItem } from "../../common/StyledComponents";
import { VALIDATION_MESSAGES } from "../../util/ClientValidator";

const REQUEST_PASSWORD_RESET_MUTATION = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email) {
      ok
    }
  }
`;

const FormContainer = styled.div`
  button {
    margin-bottom: 12px;
  }
`;

const FormFooter = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 8px;
`;

const GreyText = styled(B3)`
  color: ${colorTokens.grey750};
`;

const RequestPasswordResetForm = (props: FormComponentProps) => {
  const navigate = useNavigate();
  const { getFieldDecorator } = props.form;

  const [requestPasswordReset] = useMutation(REQUEST_PASSWORD_RESET_MUTATION, {
    client: publicClient,
    onCompleted: () => navigate(Routes.RESET_PASSWORD_SENT)
  });

  const handleSubmit = (e: any) => {
    e.preventDefault();

    props.form.validateFields((errors, values) => {
      if (errors) {
        return;
      }

      requestPasswordReset({ variables: { email: values.email } });
    });
  };

  return (
    <FormContainer>
      <Form onSubmit={handleSubmit}>
        <FormItem>
          {getFieldDecorator("email", {
            validateTrigger: "onSubmit",
            rules: [
              {
                type: "email",
                message: VALIDATION_MESSAGES.email
              },
              {
                required: true,
                whitespace: true,
                message: VALIDATION_MESSAGES.requiredField
              }
            ]
          })(<Input placeholder="Enter email address" />)}
        </FormItem>
        <FormFooter>
          <AuthCTAButton block htmlType="submit" type="brand">
            Reset Password
          </AuthCTAButton>
          <Link to={Routes.LOGIN}>
            <GreyText>Cancel</GreyText>
          </Link>
        </FormFooter>
      </Form>
    </FormContainer>
  );
};

export default Form.create<FormComponentProps>({
  name: "requestPasswordResetForm"
})(RequestPasswordResetForm);
